import React, {ReactNode} from "react"
import styled from "styled-components"


import HeaderTitle from "./HeaderTitle"

const ResponsiveFlex = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
  ${({theme}) => theme.mediaQueries.minWidthMedia.desktop`
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: ${theme.spacing.two};
  `}
`

export interface Props {
  title: string | ReactNode,
  count?: number | string | ReactNode,
  marginBottom?: number,
  children?: ReactNode
}

const AdminHeader = (props: Props) => {
  const {title, count, children, marginBottom} = props

  return (
    <ResponsiveFlex>
      <HeaderTitle title={title} count={count} marginBottom={marginBottom} />
      <div>
        {children}
      </div>
    </ResponsiveFlex>
  )
}

export default AdminHeader
